import React, { useContext, useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { ThemeContext } from 'src/theme/ThemeProvider';

const ThemeToggle = ({ sx }) => {
  const ctx = useContext(ThemeContext);
  if (!ctx) return null;
  const { themeName, setThemeName } = ctx;

  const isDark = themeName === 'NebulaFighterTheme';

  const toggle = useCallback(() => {
    setThemeName(isDark ? 'ClarkTheme' : 'NebulaFighterTheme');
  }, [isDark, setThemeName]);

  return (
    <Tooltip title={isDark ? 'Usar modo claro' : 'Usar modo noite'}>
      <IconButton
        color="primary"
        onClick={toggle}
        size="small"
        sx={{
          border: '1px solid var(--border)',
          backgroundColor: 'var(--background-card)',
          '&:hover': { backgroundColor: 'var(--primary-light)' },
          ...sx
        }}
      >
        {isDark ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
